<template>
  <nav id="sidebar" aria-label="Main Navigation">
    <!-- Side Header -->
    <div class="bg-header-dark">
      <div class="content-header bg-white-5">
        <!-- Logo -->
        <router-link
          class="fw-semibold text-white tracking-wide"
          :to="{ name: 'home' }"
        >
          <span class="smini-visible">
            <span class="opacity-75">x</span>
          </span>
          <span class="smini-hidden">
             <Logo :width="70" :height="70" currentColor="#fbfbfe"></Logo>
          </span>
        </router-link>
        <!-- END Logo -->
        <!-- Options -->
        <div>
          <!-- Toggle Sidebar Style -->
          <!-- Layout API, functionality initialized in Template._uiApiLayout() -->
          <!-- Class Toggle, functionality initialized in Helpers.dmToggleClass() -->
          <button
            type="button"
            class="btn btn-sm btn-alt-secondary"
            data-toggle="class-toggle"
            data-target="#sidebar-style-toggler"
            data-class="fa-toggle-off fa-toggle-on"
            @click="sidebarStyle"
          >
            <i :class="toggleSidebar"></i>
          </button>
          <!-- END Toggle Sidebar Style -->

          <!-- Dark Mode -->
          <!-- Layout API, functionality initialized in Template._uiApiLayout() -->
          <button
            type="button"
            class="btn btn-sm btn-alt-secondary"
            data-toggle="class-toggle"
            data-target="#dark-mode-toggler"
            data-class="far fa"
            @click="darkMode"
          >
            <i :class="toggleDarkMode"></i>
          </button>
          <!-- END Dark Mode -->

          <!-- Close Sidebar, Visible only on mobile screens -->
          <!-- Layout API, functionality initialized in Template._uiApiLayout() -->
          <button
            type="button"
            class="btn btn-sm btn-alt-secondary d-lg-none"
            data-toggle="layout"
            data-action="sidebar_close"
          >
            <i class="fa fa-times-circle"></i>
          </button>
          <!-- END Close Sidebar -->
        </div>
        <!-- END Options -->
        <div>
          <!-- Close Sidebar, Visible only on mobile screens -->
          <!-- Layout API, functionality initialized in Template._uiApiLayout() -->
          <button
            type="button"
            class="btn btn-sm btn-alt-secondary d-lg-none"
            data-toggle="layout"
            data-action="sidebar_close"
          >
            <i class="fa fa-times-circle"></i>
          </button>
          <!-- END Close Sidebar -->
        </div>
        <!-- END Options -->
      </div>
    </div>
    <!-- END Side Header -->
    <!-- Sidebar Scrolling -->
    <div class="js-sidebar-scroll">
      <!-- Side Navigation -->
      <div class="content-side">
        <ul class="nav-main">
          <li class="nav-main-item">
            <router-link :to="{ name: 'home' }" :class="dashboard">
              <i class="nav-main-link-icon fa fa-tachometer-alt"></i>
              <span class="nav-main-link-name">Tablero</span>
            </router-link>
          </li>
          
          <li class="nav-main-item">
            <router-link :to="{ name: 'notifications' }" :class="notifications">
              <i class="nav-main-link-icon fa fa-bell"></i>
              <span class="nav-main-link-name">Notificaciones</span>
              <span
                v-if="store.state.newNotificationStatus"
                class="notification-badge"
              >
              </span>
            </router-link>
          </li>

          <li class="nav-main-heading">Configuraciones</li>

          <li class="nav-main-item" v-show="$store.state.devices.length > 0">
            <router-link
              class="nav-main-link nav-main-link-submenu"
              data-toggle="submenu"
              aria-haspopup="true"
              aria-expanded="false"
              to=""
            >
              <i
                v-if="store.state.deviceActive"
                class="nav-main-link-icon fa fa-signal text-success"
              ></i>
              <i v-else class="nav-main-link-icon fa fa-times text-danger"></i>
              <span class="nav-main-link-name">{{
                $store.state.selectedDevice.name
              }}</span>
            </router-link>

            <ul v-if="store.state.deviceInfo != null" class="nav-main-submenu">
              <li class="nav-main-item">
                <router-link :to="{ name: 'device-info' }" :class="info">
                  <i class="nav-main-link-icon fa fa-cloud"></i>
                  <span class="nav-main-link-name">INFO</span>
                </router-link>
              </li>
              <li v-if="store.state.auth.userData.role != 'monitor'" class="nav-main-item">
                <a
                  @click="
                    showAlertConfirm(
                      'Reiniciar',
                      '¿Está seguro de reiniciar el dispositivo?',
                      'question',
                      'restart'
                    )
                  "
                  class="nav-main-link"
                  style="cursor: pointer"
                >
                  <i class="nav-main-link-icon fa fa-redo-alt"></i>
                  <span class="nav-main-link-name">Reiniciar</span>
                </a>
              </li>
            </ul>
          </li>

          <li class="nav-main-item" v-if="store.state.auth.userData.role != 'monitor'">
            <router-link :to="{ name: 'devices' }" :class="devices">
              <i class="nav-main-link-icon fa fa-satellite-dish"></i>
              <span class="nav-main-link-name">Dispositivos</span>
            </router-link>
          </li>

          <li class="nav-main-item">
            <router-link :to="{ name: 'traceability' }" :class="traceability">
              <i class="nav-main-link-icon fa fa-file"></i>
              <span class="nav-main-link-name">Tranzabilidad</span>
            </router-link>
          </li>

          <li class="nav-main-item">
            <router-link :to="{ name: 'alarms' }" :class="alarms">
              <i class="nav-main-link-icon fa fa-clock"></i>
              <span class="nav-main-link-name">Alarmas</span>
            </router-link>
          </li>

          <li class="nav-main-item"  v-if="store.state.auth.userData.role != 'monitor'" >
            <router-link :to="{ name: 'templates' }" :class="templates">
              <i class="nav-main-link-icon fa fa-chart-bar"></i>
              <span class="nav-main-link-name">Plantillas</span>
            </router-link>
          </li>

          <li class="nav-main-item"  v-if="store.state.auth.userData.role != 'monitor' && $store.state.selectedDevice.template != undefined " >
            <router-link :to="{ name: 'edit-templates' }" :class="editTemplates">
              <i class="nav-main-link-icon fa fa-edit"></i>
              <span class="nav-main-link-name">Editar Plantillas</span>
            </router-link>
          </li>

          <li class="nav-main-item" v-if="store.state.auth.userData.is_admin || store.state.auth.userData.role == 'admin'">
            <router-link :to="{ name: 'admin' }" :class="admin">
              <i class="nav-main-link-icon fa fa-cog"></i>
              <span class="nav-main-link-name">Administrador</span>
            </router-link>
          </li>

          <li class="nav-main-item" v-if="store.state.auth.userData.role != 'monitor'">
            <router-link :to="{ name: 'monitor-users' }" :class="monitor_users">
              <i class="nav-main-link-icon fa fa-user"></i>
              <span class="nav-main-link-name">Usuarios Monitores</span>
            </router-link>
          </li> 

          <li class="nav-main-item">
            <router-link :to="{ name: 'location-devices' }" :class="location_devices">
              <i class="nav-main-link-icon fa fa-map"></i>
              <span class="nav-main-link-name">Ubicar Dispositivos</span>
            </router-link>
          </li> 

          <li class="nav-main-heading">Acciones</li>
          <li class="nav-main-item">
            <a
              @click="
                showAlertConfirm(
                  'Sesión',
                  '¿Está seguro de cerrar la sesión?',
                  'question',
                  'logout'
                )
              "
              class="nav-main-link"
              style="cursor: pointer"
            >
              <i class="nav-main-link-icon fa fa-sign-out-alt"></i>
              <span class="nav-main-link-name">Salir</span>
            </a>
          </li>
        </ul>
      </div>
      <!-- END Side Navigation -->
    </div>
    <!-- END Sidebar Scrolling -->
  </nav>
</template>

<script>
import { computed, onMounted, ref, inject } from "vue";
import useApp from "@/composables/useApp";
import { useStore } from "vuex";
import emitter from "@/eventBus";
import Logo from "../Logo.vue";
import Traceability from "@/views/Traceability.vue";

export default {
  name: "Sidebar",
  components:{
    Logo
  },
  setup() {
    const swal = inject("$swal")
    const store = useStore();
    const {route, logOut, restartDevice } = useApp();
    const dash_style = ref({ dark_mode: true, sidebar_style: false });
    const deviceStatus = ref(false);
    onMounted(() => {
      emitter.on(store.state.selectedDevice.dId, () => {
        deviceStatus.value = true;
        console.log(deviceStatus.value);
      });
      store.dispatch("getDashStyle");
      if (store.state.dashStyle == null) {
        store.commit("setDashboardStyle", dash_style.value);
      }
      setTimeout(() => {
        dash_style.value = store.state.dashStyle;
        if (dash_style.value.sidebar_style == true) {
          Dashmix.layout("header_style_light");
          Dashmix.layout("sidebar_style_light");
        } else {
          Dashmix.layout("header_style_dark");
          Dashmix.layout("sidebar_style_dark");
        }
        dash_style.value.dark_mode == true
          ? Dashmix.layout("dark_mode_on")
          : Dashmix.layout("dark_mode_off");
      }, 300);
    });

    const showAlertConfirm = (title, text, icon, funct) => {
      swal({
        title: title,
        text: text,
        icon: icon,
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          if (funct == "restart") {
            restartDevice()
            console.log("reinciar Dispositivo");
          } else {
            logOut();
          }
        }
      });
    };
    const index = computed(() => {
      return route.path == "/" ? "nav-main-link active" : "nav-main-link";
    });

    const dashboard = computed(() => {
      return route.path == "/dashboard"
        ? "nav-main-link active"
        : "nav-main-link";
    });

    const monitor_users = computed(()=>{
      return route.path == "/monitor-users" ? "nav-main-link active" : "nav-main-link";
    })
    const wifi = computed(() => {
      return route.path == "/wifi" ? "nav-main-link active" : "nav-main-link";
    });

    const info = computed(() => {
      return route.path == "/cloud" ? "nav-main-link active" : "nav-main-link";
    });

    const location_devices = computed(() => {
      return route.path == "/location-devices" ? "nav-main-link active" : "nav-main-link";
    });

    const settings = computed(() => {
      return route.path == "/settings"
        ? "nav-main-link active"
        : "nav-main-link";
    });

    const editTemplates = computed(() => {
      return route.path == "/edit-templates"
        ? "nav-main-link active"
        : "nav-main-link";
    });

    const devices = computed(() => {
      return route.path == "/devices"
        ? "nav-main-link active"
        : "nav-main-link";
    });

    const notifications = computed(() => {
      return route.path == "/notifications"
        ? "nav-main-link active"
        : "nav-main-link";
    });

    const alarms = computed(() => {
      return route.path == "/alarms" ? "nav-main-link active" : "nav-main-link";
    });
    const templates = computed(() => {
      return route.path == "/templates"
        ? "nav-main-link active"
        : "nav-main-link";
    });

    const traceability = computed(()=>{
      return route.path == "/traceability"
      ? "nav-main-link active"
      : "nav-main-link";
    })

    const admin = computed(() => {
      return route.path == "/admin" ? "nav-main-link active" : "nav-main-link";
    });
    const toggleDarkMode = computed(() => {
      return dash_style.value.dark_mode == true ? "fa-moon fa" : "fa-moon far";
    });

    const toggleSidebar = computed(() => {
      return dash_style.value.sidebar_style == true
        ? "fa fa-toggle-on"
        : "fa fa-toggle-off";
    });

    const darkMode = () => {
      if (dash_style.value.dark_mode == true) {
        Dashmix.layout("dark_mode_off");
        dash_style.value.dark_mode = false;
      } else {
        Dashmix.layout("dark_mode_on");
        dash_style.value.dark_mode = true;
      }
      store.commit("setDashboardStyle", dash_style.value);
    };

    const sidebarStyle = () => {
      if (dash_style.value.sidebar_style == true) {
        Dashmix.layout("sidebar_style_dark");
        Dashmix.layout("header_style_dark");
        dash_style.value.sidebar_style = false;
      } else {
        Dashmix.layout("header_style_light");
        Dashmix.layout("sidebar_style_light");
        dash_style.value.sidebar_style = true;
        dash_style.value.dark_mode = false;
      }
      store.commit("setDashboardStyle", dash_style.value);
    };

    return {
      index,
      wifi,
      info,
      monitor_users,
      settings,
      devices,
      traceability,
      alarms,
      templates,
      store,
      admin,
      editTemplates,
      showAlertConfirm,
      logOut,
      darkMode,
      sidebarStyle,
      toggleDarkMode,
      toggleSidebar,
      notifications,
      deviceStatus,
      dashboard,
      location_devices
    };
  },
};
</script>

<style>
.notification-badge {
  position: relative;
  top: 0;
  right: 0;
  width: 12px;
  height: 12px;
  background-color: red;
  border-radius: 50%;
  border: 2px solid white; /* Para dar un borde blanco y que se vea mejor */
}
</style>
